export interface IContactsAnalyticsByCountry {
    by_billing_address: IContactsAnalyticsByCountryItem[];
    by_shipping_address: IContactsAnalyticsByCountryItem[];
}

export interface IContactsAnalyticsByCountryItem {
    count: number;
    country_name: string;
}
